<!--
 * @Author: your name
 * @Date: 2024-03-12 20:23:12
 * @LastEditTime: 2024-08-15 15:47:08
 * @LastEditors: your name
 * @Description: 
 * @FilePath: \web_BullyingPrevention\src\App.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
  <div id="app">
    <router-view/>
        <!-- 一个div -->
        
  </div>
</template>

<script>
import { Client } from '@stomp/stompjs'
import SockJS from 'sockjs-client'
import { getCurrentSchoolId } from '@/utils/sessionAuth'

export default {
  data () {
    return {
      schoolId: sessionStorage.getItem('schoolId'),
      stompClient: null,
      subscription: null,
    }
  },
  mounted () {
    this.schoolId = getCurrentSchoolId()
    this.initStomp()
  },
  methods: {
    getWsUrl () {
      return sessionStorage.getItem('api')
        ? 'https://api.qingzhou.link/fblv2/ws'
        : 'https://api.qingzhou.link/fbl/ws'
    },
    initStomp () {
      const that = this
      const client = new Client({
        // 使用 SockJS 作为底层传输
        webSocketFactory: () => new SockJS(that.getWsUrl()),
        // 心跳：每10秒发送/接收一次
        heartbeatIncoming: 10000,
        heartbeatOutgoing: 10000,
        // 断线后自动重连，间隔5秒
        reconnectDelay: 5000,
        onConnect: () => {
          console.log('STOMP 已连接')
          that.subscription = client.subscribe('/event/' + that.schoolId, (message) => {
            console.log('收到消息', message.body)
            const body = JSON.parse(message.body)
            that.$api.webApi.getEventDetail(body.id).then(res => {
              if (res.code === 200) {
                that.$bus.$emit('busEvent', { message: res.data })
              }
            })
          })
        },
        onDisconnect: () => {
          console.log('STOMP 已断开，等待自动重连...')
        },
        onStompError: (frame) => {
          console.error('STOMP 错误', frame)
        },
        onWebSocketError: (event) => {
          console.error('WebSocket 错误', event)
        },
      })

      this.stompClient = client
      client.activate()
    },
  },
  beforeDestroy () {
    this.$EventBus.$off('busEvent')
    if (this.stompClient) {
      this.stompClient.deactivate()
      this.stompClient = null
    }
  },
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  position: relative;
}
/* 自定义整个滚动条 */
::-webkit-scrollbar {
  width: 6px; /* 设置滚动条的宽度 */
  height: 6px;
  
}
/* 修改滚动条轨道背景色 */
::-webkit-scrollbar-track {
  background-color: #fff;
}
 
/* 修改滚动条滑块颜色 */
::-webkit-scrollbar-thumb {
  background-color: #eaeaea;
  border-radius: 10px;
  cursor: pointer;
}
 
/* 修改滚动条滑块悬停时的颜色 */
::-webkit-scrollbar-thumb:hover {
  background-color: #eaeaea;
}


</style>
